import { TOOL_DETAIL_PATTERN } from './progressLabelData.js'
import { dedupeFriendlyRows, friendlyProgressLabel } from './progressLabelCore.js'
import {
  friendlyProgressStatus,
  friendlyToolProgressLabel,
  isToolProgressEvent,
} from './progressLabelText.js'

export function friendlyProgressDetails(events, limit = 40) {
  const rows = []
  let toolCount = 0
  let toolStatus = 'done'
  for (const event of Array.isArray(events) ? events : []) {
    if (!event || typeof event !== 'object') continue
    if (isToolProgressEvent(event)) {
      toolCount += 1
      if (friendlyProgressStatus(event.status) !== 'done') {
        toolStatus = friendlyProgressStatus(event.status)
      }
      continue
    }
    rows.push(`${friendlyProgressLabel(event)} · ${friendlyProgressStatus(event.status)}`)
  }
  if (toolCount) rows.push(`${friendlyToolProgressLabel(toolCount)} · ${toolStatus}`)
  return dedupeFriendlyRows(rows).slice(-limit)
}

export function mergeToolProgressDetails(details, toolCount, status = 'done', limit = 40) {
  const rows = Array.isArray(details)
    ? details.filter((detail) => !TOOL_DETAIL_PATTERN.test(detail))
    : []
  if (toolCount > 0) rows.push(`${friendlyToolProgressLabel(toolCount)} · ${status}`)
  return dedupeFriendlyRows(rows).slice(-limit)
}
